<!-- 个人信息页面 -->
<template>
    <div class="personal-info">
        <!-- 一级菜单 -->
        <veui-tabs
            ui="l"
            :active.sync="curTab"
        >
            <veui-tab
                label="个人信息"
                name="info"
            />
            <veui-tab
                label="个人主页"
                name="home"
            />
        </veui-tabs>
        <div class="content">
            <info v-if="curTab === 'info'" @updateBanner="updateBanner" />
            <home v-else :banner-config="bannerConfig" />
        </div>
        <preview-card
            v-if="curTab === 'info'"
            class="preview-btn"
            @clickPreview="curTab = 'home'"
        />
    </div>
</template>

<script>
import info from './components/info.vue';
import home from './components/home.vue';
import previewCard from './components/preview-card.vue';

import {
    Tabs,
    Tab
} from 'veui';

export default {
    name: 'personalInfo',
    components: {
        'veui-tabs': Tabs,
        'veui-tab': Tab,
        info,
        home,
        'preview-card': previewCard
    },
    data() {
        return {
            curTab: 'info',
            bannerConfig: {}
        };
    },
    methods: {
        updateBanner(data = {}) {
            this.bannerConfig = data;
        }
    }
};
</script>

<style lang='less' scoped>
.personal-info {
    background: #fff;
    box-shadow: 0px 6px 14px 0px rgba(227, 233, 237, 0.35);
    border-radius: 8px;
    padding: 8px 30px 30px;

    .content {
        height: calc(100% - 58px);
        overflow: hidden;
    }

    .preview-btn {
        position: fixed;
        left: calc(50vw + 425px);
        top: 190px;
    }
}
</style>
